import { Component, type OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent implements OnInit {

  constructor(
    private readonly _router: Router
  ) { }

  ngOnInit(): void { }

  goHome() {
    this._router.navigate(['/']);
  }

}
